import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ProjectGroupTypeDetails from "./routes/ProjectGroupTypeDetails";
export default store => {
  return {
    path: "project-group-types",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([import("./components")]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [ProjectGroupTypeDetails(store)],
  };
};
